import type { TranslationResources } from './en'

export const ru: TranslationResources = {
  app: {
    name: 'LogarGo',
    adminConsole: 'Панель администратора',
  },
  nav: {
    dashboard: 'Панель',
    shipments: 'Отправления',
    statistics: 'Статистика',
    shipmentRequests: 'Запросы на отправку',
    jobs: 'Задания',
    jobOffers: 'Предложения работы',
    smsOptOuts: 'Отписки от SMS',
    mitigationLadder: 'Лестница смягчения',
    accounts: 'Аккаунты',
    allAccounts: 'Все аккаунты',
    shippers: 'Отправители',
    freighters: 'Перевозчики',
    drivers: 'Водители',
    vehicles: 'Транспорт',
    liveTracking: 'Отслеживание',
    verifications: 'Проверки',
    disputes: 'Споры',
    scores: 'Оценки',
    finance: 'Финансы',
    subscriptions: 'Подписки',
    activeSubscriptions: 'Активные подписки',
    plans: 'Тарифы',
    entitlements: 'Дополнения',
    campaigns: 'Кампании',
    billingControl: 'Управление биллингом',
    notifications: 'Уведомления',
    cronJobs: 'Задачи по расписанию',
    systemHealth: 'Состояние системы',
    systemConfiguration: 'Настройки системы',
    settings: 'Настройки',
  },
  topbar: {
    switchToDark: 'Переключить на тёмную тему',
    switchToLight: 'Переключить на светлую тему',
    notifications: 'Уведомления',
    profileSettings: 'Настройки профиля',
    logout: 'Выйти',
    administrator: 'Администратор',
    detach: 'Открепить страницу',
    openNewTab: 'Открыть в новой вкладке',
    openNewWindow: 'Открыть в новом окне',
  },
  settings: {
    title: 'Настройки',
    subtitle: 'Управление профилем, языком и оформлением.',
    profileSection: 'Профиль',
    name: 'Имя',
    email: 'Эл. почта',
    phone: 'Телефон',
    role: 'Роль',
    status: 'Статус',
    accountId: 'ID аккаунта',
    preferencesSection: 'Предпочтения',
    language: 'Язык',
    languageHelp:
      'Обновляет locale аккаунта на сервере. Вы выйдете из системы, метки enum загрузятся при следующем входе.',
    languageChangeTitle: 'Сменить язык',
    languageChangeConfirm: 'Переключить интерфейс и метки enum на {{language}}?',
    languageChangeConfirmHint:
      'Locale аккаунта будет обновлён на сервере. Вы выйдете из системы, как в мобильных приложениях.',
    languageChangeConfirmAction: 'Сменить и выйти',
    languageChangeFailed: 'Не удалось обновить язык',
    appearance: 'Оформление',
    themeMode: 'Тема',
    lightMode: 'Светлая',
    darkMode: 'Тёмная',
    languageChanged: 'Язык обновлён',
    themeChanged: 'Тема обновлена',
    notProvided: 'Не указано',
  },
  login: {
    subtitle: 'Панель администратора',
    emailLabel: 'Адрес эл. почты',
    emailPlaceholder: 'admin@example.com',
    passwordLabel: 'Пароль',
    signIn: 'Войти',
    signingIn: 'Вход...',
    requiresAdmin: 'Требуются права SYSTEM_ADMIN',
    accessDenied: 'Доступ запрещён. Требуется роль SYSTEM_ADMIN.',
    loginFailed: 'Не удалось войти. Попробуйте снова.',
    copyright: '© {{year}} LogarGo. Платформа подбора отправителей и перевозчиков.',
  },
  languages: {
    EN: 'Английский',
    HE: 'Иврит',
    AR: 'Арабский',
    RU: 'Русский',
  },
}
